import { clearCacheByPattern } from '../hooks/useCache';

/**
 * Invalidates all list cache entries for the given bucket and then calls
 * the provided refresh function to re-fetch the current listing.
 *
 * Replaces the repeated two-step pattern:
 *   clearCacheByPattern(new RegExp(`objects-${bucketName}`));
 *   refreshCache();
 *
 * @param bucketName   - The S3 bucket name whose cache entries should be invalidated.
 * @param refreshCache - The cache refresh callback from useCache().
 */
export function invalidateAndRefresh(bucketName: string, refreshCache: () => void): void {
  clearCacheByPattern(new RegExp(`objects-${bucketName}`));
  refreshCache();
}
